'use strict';

angular.module('shiftTraderApp')
    .directive('saNoteMessageCompose', ['$sce', 'PositionsStore', 'UsersStore',
        'TagCloudStore', 'NoteMessagesService', 'LibraryStore', function ($sce, PositionsStore,
        UsersStore, TagCloudStore, NoteMessagesService, LibraryStore) {

      return {
        restrict: 'A',
        scope: {},
        bindToController: {
          message: '=',
          placeholder: '@'
        },
        require: '^saNoteCreate',
        controllerAs: 'composeCtrl',
        template: '<div class="sa-note-message-content-compose" ng-bind-html="::composeCtrl.htmlMessage" contenteditable="true" data-placeholder="{{::composeCtrl.placeholder}}"></div>',
        controller: ['$scope','$sce', 'NoteMessagesService', function($scope, $sce, NoteMessagesService) {
          this.htmlMessage = $sce.trustAsHtml(NoteMessagesService.toHTML(this.message || ""))
        }],

        link: function(scope, element, attrs, parentCtrl) {
          var editor = $(element).children('.sa-note-message-content-compose:first:not(.initialized)');

          // Call parent throttled message parsing + media detection.
          function triggerUpdate() {
            parentCtrl.setMessage(editor.html());
          }

          $(editor).on('focus blur keyup input change', triggerUpdate);

          scope.$on('saNoteCreate:createSuccessful', function() {
            editor.empty();
            triggerUpdate();
          });

          // Remote filter callbacks
          function getUsersAndPositions(query, callback) {
            // TODO -- This should be replaced with a simple call to a UsersAndPositionsStore
            //      -- The resulting code here should be as concise as the getTags() function
            //         below
            var users = void 0;
            var positions = void 0;
            var merged = void 0;

            function tryMerge() {
              if (users && positions) {
                return merged = $.merge(users, positions);
              }
              return 0;
            }

            UsersStore.getAll(query).then(function(data) {
              users = lodash.map(data, function(e) {
                return {type: 'User', id: e.id, name: e.name}
              });
              tryMerge() && callback(merged)
            });

            PositionsStore.getAllActive(query).then(function(data) {
              positions = lodash.map(data, function(e) {
                return {type: 'Position', id: e.id, name: e.name}
              });
              tryMerge() && callback(merged)
            })
          }

          function getTags(query, callback) {
            return TagCloudStore.getAll(query).then(callback);
          }

          var atwhoObject;

          LibraryStore.load('Atjs').then(function() {
            // Atwho bindings
            atwhoObject = $(editor)
              .atwho({
                at: '@',
                insertTpl: "<span class='mention' data-model-type='${type}' data-model-id='${id}' data-model-label='${name}'>${name}</span>",
                callbacks: {
                  remoteFilter: getUsersAndPositions
                }
              }).atwho({
                at: '#',
                insertTpl: "<span class='mention' data-model-type='Tag', data-model-id='${name}' data-model-label='${name}'>${atwho-at}${name}</span>",
                callbacks: {
                  remoteFilter: getTags,
                  afterMatchFailed: function(at, el) {
                    if('#' == at) {
                      el.data('item-data', {'atwho-at': '#'});
                      var txt = el.text().trim();
                      var cont = "<span class='mention', data-model-type='Tag', data-model-id='"+txt+"' data-model-label='"+txt+"'>"+txt+"</span>";
                      this.insert(cont, el);
                      return false;
                    }
                  }
                },
                acceptSpaceBar: true
              }).addClass('initialized')
            }, function() {
            console.log('atjs failed to load');
          });

          scope.$on('$destroy', function() {
            if (atwhoObject) {
              atwhoObject.atwho('destroy');
            }
          });

        }
      };
    }]);
